import { uuid } from 'vue-uuid';
import { IAddressVueModel } from '@/ts/models/IAddressVueModel';
import { IContactVueModel } from '@/ts/models/IContactVueModel';

export class FormFunctions {
    isNullOrEmpty(value: string): boolean {
        return value === undefined || value === null || value === "";
    }

    isNullOrEmptyOrZero(value: number|any): boolean {
        return this.isNullOrEmpty(value) || (value as number) === NaN || (value as number) * 1 === 0;
    }

    isValidEmail(value: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    getEmptyAddress(): IAddressVueModel {
        return {
            id: uuid.v4(),
            addressType: "",
            streetType: "",
            streetNumber: "",
            streetName: "",
            streetDirection: "",
            street2: "",
            city: "",
            state: "IL",
            zip: "",
            country: ""
        }
    }

    getEmptyContact(): IContactVueModel {
        return {
            id: uuid.v4(),
            objectId: "",
            contactType: "",
            name: "",
            phone: "",
            email: "",
            firstName: "",
            lastName: "",
            address: this.getEmptyAddress()
        }
    }

    moneyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

    toMoney(value: number): string {
        return this.moneyFormatter.format(value);
    }
}

export default new FormFunctions();